/**
 * useSetRitualCoverImage Hook
 * Mutation hook for setting ritual cover image
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"
import { apiClient } from "@/lib/api-client"

interface SetRitualCoverImageVariables {
  ritualId: string
  uploadId: string
}

export function useSetRitualCoverImage() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ ritualId, uploadId }: SetRitualCoverImageVariables) => {
      const response = await apiClient.patch<{
        success: boolean
        data: { id: string; filePath: string; isCover: boolean }
        message: string
      }>(`/api/rituals/${ritualId}/images/${uploadId}/cover`)

      return response.data.data
    },

    onSuccess: () => {
      // Invalidate ritual query to refetch
      queryClient.invalidateQueries({
        queryKey: ["ritual"],
      })
      toast.success("Cover image updated")
    },

    onError: () => {
      toast.error("Failed to update cover image")
    },
  })
}
